/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { CustomerEntry } from './CustomerEntry.js';
import {
    CustomerEntryFromJSON,
    CustomerEntryFromJSONTyped,
    CustomerEntryToJSON,
} from './CustomerEntry.js';

/**
 * 
 * @export
 * @interface CreateContactEntryResponse
 */
export interface CreateContactEntryResponse {
    /**
     * 
     * @type {CustomerEntry}
     * @memberof CreateContactEntryResponse
     */
    data?: CustomerEntry;
    /**
     * 
     * @type {number}
     * @memberof CreateContactEntryResponse
     */
    totalRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateContactEntryResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateContactEntryResponse
     */
    pages?: number;
    /**
     * 
     * @type {Array<Error>}
     * @memberof CreateContactEntryResponse
     */
    errors?: Array<Error>;
}

/**
 * Check if a given object implements the CreateContactEntryResponse interface.
 */
export function instanceOfCreateContactEntryResponse(value: object): boolean {
    return true;
}

export function CreateContactEntryResponseFromJSON(json: any): CreateContactEntryResponse {
    return CreateContactEntryResponseFromJSONTyped(json, false);
}

export function CreateContactEntryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateContactEntryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : CustomerEntryFromJSON(json['data']),
        'totalRecords': json['totalRecords'] == null ? undefined : json['totalRecords'],
        'page': json['page'] == null ? undefined : json['page'],
        'pages': json['pages'] == null ? undefined : json['pages'],
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function CreateContactEntryResponseToJSON(value?: CreateContactEntryResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': CustomerEntryToJSON(value['data']),
        'totalRecords': value['totalRecords'],
        'page': value['page'],
        'pages': value['pages'],
        'errors': value['errors'],
    };
}

